export default __webpack_public_path__ + "static/media/typewriter.86ec40f2.jpg";